import { render, staticRenderFns } from "./DeviceBaseInfo.vue?vue&type=template&id=5af85a93&scoped=true&"
import script from "./DeviceBaseInfo.vue?vue&type=script&lang=js&"
export * from "./DeviceBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeviceBaseInfo.vue?vue&type=style&index=0&id=5af85a93&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af85a93",
  null
  
)

export default component.exports